
export default {
    name: 'SidebarMobileBurger',
    data() {
        return {
            openBurger: false
        }
    },
    methods: {

    }
}
